module.exports = __webpack_public_path__ + "static/walking-in-front-of-a-truck-fa36f645050fba397f402547a004f159.jpg";